import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CurrentUserInfo } from 'src/app/core/models/currentUserInfo';
import { Journey, IotAsset } from 'src/app/core/models/iotAssetsModel.data';
import { ActiaJourneyService } from 'src/app/core/services/actia-journey.service';
import { ActiaMapService } from 'src/app/core/services/actia-map.service';
import { DataService } from 'src/app/core/services/data.service';
import { MapContainerService } from 'src/app/core/services/mapContainer.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import { CatalogService } from 'src/app/core/services/catalog.service';
import { KpiCrudService, WidgetRequest } from 'src/app/core/services/kpi-crud.service';
import { Subject, forkJoin, Observable } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'src/app/appState.interface';
import { selectedCustomerSelector } from 'src/app/core/store/selectors';
import { select } from '@ngrx/store';

@Component({
  selector: 'app-journey-details',
  templateUrl: './journey-details.component.html',
  styleUrls: ['./journey-details.component.scss']
})
export class ActiaJourneyDetailsComponent implements OnInit, OnChanges, OnDestroy {

 // Subject per gestire le unsubscribe automaticamente
 private destroy$ = new Subject<void>();

 // Variabile privata per memorizzare i journey
 private _journeyData: Journey[] = [];
 isJourneyLoading = false;
 // Getter e setter per l'input listDataJourney
 @Input()
 set listDataJourney(journeys: Journey[]) {
   if (journeys && journeys.length > 0) {
     // Ordina per trip_id in ordine discendente (dal più recente al più vecchio)
     this._journeyData = [...journeys].sort((a, b) => b.trip_id - a.trip_id);
    console.log('Journey ordinati per trip_id (discendente):', this._journeyData);
   } else {
     this._journeyData = [];
   }
 }

 get listDataJourney(): Journey[] {
   return this._journeyData;
 }

 @Input() routeSummaries: any[] = [];
 calculatedRouteDistance: number | null = null;

journeySettings: { [tripId: number]: { highFrequency: boolean } } = {};

// Configurazione KPI journey
journeyKpiList: any[] = []; // Scope 'kpi'
journeyKpiCustomList: any[] = []; // Scope 'kpi_custom'

// Mappa per i KPI di ogni singolo journey
journeyKpiData: Map<number, { kpiList: any[], kpiCustomList: any[] }> = new Map();

// Stati accordion per KPI per ogni journey
journeyKpiAccordionState: Map<number, { kpiOpen: boolean, kpiCustomOpen: boolean }> = new Map();

@Input() backClicked: boolean;
@Input() vehicle: IotAsset | null = null; // Input parameter per il veicolo
  @Output() cardClicked = new EventEmitter<{index: number, selected: boolean}>();
   @Output() highFrequency = new EventEmitter<{index: number, show: boolean}>();

  constructor(private mapContainerService: MapContainerService,private translate: TranslateService,
        private dataService: DataService,    public mapService: ActiaMapService,  public utlService: UtilsService,
        public journeyService:ActiaJourneyService,
          private cdr: ChangeDetectorRef,
          private catalogService: CatalogService,
          private kpiCrudService: KpiCrudService,
          private store: Store<AppStateInterface>,
            public utilsService: UtilsService
        ) {}



   ngOnInit() {
     console.log('SELECTED VEHICLE', this.vehicle);
    // Sottoscrivi l'observable per essere notificato dei cambiamenti
    this.mapContainerService.journeyLoading$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isLoading => {
        this.isJourneyLoading = isLoading;
      });

 this.listDataJourney.forEach(journey => {
    this.journeySettings[journey.trip_id] = {
      highFrequency: false // Valore iniziale
    };
  });

  }

ngOnDestroy(): void {
  this.destroy$.next();
  this.destroy$.complete();
}

onCardClick(tripId: number): void {
    // Controlla se c'è un'operazione in corso prima di procedere
    if (this.isJourneyLoading) {
      console.log('Operazione in corso, click ignorato');
      return;
    }
  // Trova il journey con questo trip_id
  const journeyIndex = this._journeyData.findIndex(j => j.trip_id === tripId);
  if (journeyIndex === -1) {
    console.error(`Journey con trip_id ${tripId} non trovato`);
    return;
  }

  const journey = this._journeyData[journeyIndex];

  // Toggle dello stato di selezione
  journey.selected = !journey.selected;

  console.log(`Journey ${tripId} ${journey.selected ? 'selezionato' : 'deselezionato'}`);

  // Emetti l'evento con il trip_id e lo stato di selezione
  this.cardClicked.emit({
    index: tripId,  // Passa il trip_id invece dell'indice
    selected: journey.selected
  });
}
formatDate(dateString: string): string {
  if (!dateString) return 'N/D';

  const date = new Date(dateString);
  return date.toLocaleString('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

// journey-details.component.ts

/**
 * Calcola il tempo di pausa tra due journey
 * @param previousJourney Il journey precedente
 * @param currentJourney Il journey corrente
 * @returns Una stringa formattata con il tempo di pausa
 */
calculatePauseTime(journey: Journey): string {
  return this.journeyService.calculatePauseTime(journey);
  // if (!journey || !journey.short_parked_duration) {
  //   return 'N/D';
  // }

  // // Usa direttamente il valore short_parked_duration
  // const duration = journey.parked_duration_before_next_journey;

  // // Se è già in formato HH:MM:SS, lo convertiamo in un formato più leggibile
  // const parts = duration ? duration.split(':') : [];
  // if (parts.length === 3) {
  //   const hours = parseInt(parts[0]);
  //   const minutes = parseInt(parts[1]);
  //   const seconds = parseInt(parts[2]);


  // const lblHours = this.translate.instant('mapPage.hours');
  // const lblMinutes = this.translate.instant('mapPage.minutes');
  //   const lblSeconds = this.translate.instant('mapPage.seconds');

  //   if (hours > 0) {
  //     return `${hours} ${lblHours} - ${minutes} ${lblMinutes}`;
  //   } else if (minutes > 0) {
  //     return `${minutes} ${lblMinutes}`;
  //   } else {
  //     return `${seconds} ${lblSeconds}`;
  //   }
  // }

  // // Se il formato non è riconoscibile, ritorna il valore grezzo
  // return duration || 'N/D';
}

// Calcola la durata totale di tutti i viaggi
calculateTotalDuration(): string {
  return this.journeyService.calculateTotalDuration(this.listDataJourney);
  // if (!this.listDataJourney || this.listDataJourney.length === 0) return 'N/D';

  // let totalSeconds = 0;

  // this.listDataJourney.forEach(journey => {
  //   if (journey.journey_duration) {
  //     // Assumendo che journey_duration sia nel formato "HH:MM:SS"
  //     const parts = journey.journey_duration.split(':');
  //     if (parts.length === 3) {
  //       const hours = parseInt(parts[0]);
  //       const minutes = parseInt(parts[1]);
  //       const seconds = parseInt(parts[2]);
  //       totalSeconds += hours * 3600 + minutes * 60 + seconds;
  //     }
  //   }
  // });

  // // Converti i secondi in formato "HH:MM:SS"
  // const hours = Math.floor(totalSeconds / 3600);
  // const minutes = Math.floor((totalSeconds % 3600) / 60);
  // const seconds = totalSeconds % 60;

  // return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}


// Calcola la durata totale di tutti i viaggi
calculateWorkingDuration(): string {
  return this.journeyService.calculateWorkingDurationNew(this.listDataJourney);
  // if (!this.listDataJourney || this.listDataJourney.length === 0) return 'N/D';

  // let totalSeconds = 0;

  // this.listDataJourney.forEach(journey => {
  //   if (journey.keyon_duration) {
  //     // Assumendo che journey_duration sia nel formato "HH:MM:SS"
  //     const parts = journey.journey_duration.split(':');
  //     if (parts.length === 3) {
  //       const hours = parseInt(parts[0]);
  //       const minutes = parseInt(parts[1]);
  //       const seconds = parseInt(parts[2]);
  //       totalSeconds += hours * 3600 + minutes * 60 + seconds;
  //     }
  //   }
  // });

  // // Converti i secondi in formato "HH:MM:SS"
  // const hours = Math.floor(totalSeconds / 3600);
  // const minutes = Math.floor((totalSeconds % 3600) / 60);
  // const seconds = totalSeconds % 60;

  // return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}/h`;
}

// Calcola la distanza totale percorsa
calculateTotalDistance(): string {
  return this.journeyService.calculateTotalDistance(this.listDataJourney);
}

// Metodo helper per ottenere la distanza da visualizzare
getDisplayDistance(): { value: string; isCalculated: boolean } {
  if (this.calculatedRouteDistance !== null) {
    return {
      value: this.calculatedRouteDistance.toFixed(2),
      isCalculated: true
    };
  }
  const originalDistance = this.calculateTotalDistance();
  return {
    value: originalDistance || '0',
    isCalculated: false
  };
}

// Calcola il carburante totale consumato
calculateTotalFuel(): string {
  return this.journeyService.calculateTotalFuel(this.listDataJourney);
  // if (!this.listDataJourney || this.listDataJourney.length === 0) return '0';

  // const totalFuel = this.listDataJourney.reduce((sum, journey) => {
  //   return sum + (journey.total_fuel_consumed || 0);
  // }, 0);

  // return this.mapService.formatNumber(totalFuel);
}

// Calcola l'efficienza media del carburante
calculateAverageFuelEfficiency(): string {
  return this.journeyService.calculateAverageFuelEfficiencyNew(this.listDataJourney);
  // if (!this.listDataJourney || this.listDataJourney.length === 0) return '0';

  // const totalDistance = this.listDataJourney.reduce((sum, journey) => {
  //   return sum + (journey.total_km || 0);
  // }, 0);

  // const totalFuel = this.listDataJourney.reduce((sum, journey) => {
  //   return sum + (journey.total_fuel_consumed || 0);
  // }, 0);

  // if (totalDistance === 0) return '0';

  // // Formula per l/100km
  // const avgEfficiency = (totalFuel / totalDistance) * 100;
  // return this.mapService.formatNumber(avgEfficiency);
}

// Calcola il tempo totale di movimento
calculateTotalMovingTime(): string {
  return  this.journeyService.calculateTotalMovingTime(this.listDataJourney);
  // if (!this.listDataJourney || this.listDataJourney.length === 0) return 'N/D';

  // let totalSeconds = 0;

  // this.listDataJourney.forEach(journey => {
  //   if (journey.journey_duration) {
  //     // Assumendo che moving_time sia nel formato "HH:MM:SS"
  //     const parts = journey.journey_duration.split(':');
  //     if (parts.length === 3) {
  //       const hours = parseInt(parts[0]);
  //       const minutes = parseInt(parts[1]);
  //       const seconds = parseInt(parts[2]);
  //       totalSeconds += hours * 3600 + minutes * 60 + seconds;
  //     }
  //   }
 //});

  // // Converti i secondi in formato "HH:MM:SS"
  // const hours = Math.floor(totalSeconds / 3600);
  // const minutes = Math.floor((totalSeconds % 3600) / 60);
  // const seconds = totalSeconds % 60;

  // return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}
// Calcola il tempo totale di stop (somma di parked_duration_before_next_journey)
calculateTotalStopTime(): string {
  return this.journeyService.calculateTotalStopTime(this.listDataJourney);
  // if (!this.listDataJourney || this.listDataJourney.length === 0) return 'N/D';

  // let totalSeconds = 0;

  // this.listDataJourney.forEach(journey => {
  //   if (journey.parked_duration_before_next_journey) {
  //     // Assumendo che parked_duration_before_next_journey sia nel formato "HH:MM:SS"
  //     const parts = journey.parked_duration_before_next_journey ? journey.parked_duration_before_next_journey.split(':') : [];
  //     if (parts.length === 3) {
  //       const hours = parseInt(parts[0]);
  //       const minutes = parseInt(parts[1]);
  //       const seconds = parseInt(parts[2]);
  //       totalSeconds += hours * 3600 + minutes * 60 + seconds;
  //     }
  //   }
  // });



  // // Converti i secondi in formato "HH:MM:SS"
  // const hours = Math.floor(totalSeconds / 3600);
  // const minutes = Math.floor((totalSeconds % 3600) / 60);
  // const seconds = totalSeconds % 60;

  // return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}/h`;
}

calculateTotalShortStopTime(): string {
  return this.journeyService.calculateTotalShortStopTime(this.listDataJourney);
  // if (!this.listDataJourney || this.listDataJourney.length === 0) return 'N/D';

  // let totalSeconds = 0;

  // this.listDataJourney.forEach(journey => {
  //   if (journey.short_parked_duration) {
  //     // Assumendo che parked_duration_before_next_journey sia nel formato "HH:MM:SS"
  //     const parts = journey.short_parked_duration ? journey.short_parked_duration.split(':') : [];
  //     if (parts.length === 3) {
  //       const hours = parseInt(parts[0]);
  //       const minutes = parseInt(parts[1]);
  //       const seconds = parseInt(parts[2]);
  //       totalSeconds += hours * 3600 + minutes * 60 + seconds;
  //     }
  //   }
  // });





  // // Converti i secondi in formato "HH:MM:SS"
  // const hours = Math.floor(totalSeconds / 3600);
  // const minutes = Math.floor((totalSeconds % 3600) / 60);
  // const seconds = totalSeconds % 60;

  // return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}/h`;
}


calculateTotalIdleTime(): string {
  return this.journeyService.calculateTotalIdleTime(this.listDataJourney);
  // if (!this.listDataJourney || this.listDataJourney.length === 0) return 'N/D';

  // let totalSeconds = 0;

  // this.listDataJourney.forEach(journey => {
  //   if (journey.idle_time) {
  //     // Assumendo che parked_duration_before_next_journey sia nel formato "HH:MM:SS"
  //     const parts = journey.idle_time ? journey.idle_time.split(':') : [];
  //     if (parts.length === 3) {
  //       const hours = parseInt(parts[0]);
  //       const minutes = parseInt(parts[1]);
  //       const seconds = parseInt(parts[2]);
  //       totalSeconds += hours * 3600 + minutes * 60 + seconds;
  //     }
  //   }
  // });





  // // Converti i secondi in formato "HH:MM:SS"
  // const hours = Math.floor(totalSeconds / 3600);
  // const minutes = Math.floor((totalSeconds % 3600) / 60);
  // const seconds = totalSeconds % 60;

  // return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}/h`;
}


/**
 * Recupera l'indirizzo di partenza del primo journey
 */
getStartAddress(): string {
  // console.log('getStartAddress called');
  // console.log('listDataJourney:', this.listDataJourney);
  return this.journeyService.getStartAddress(this.listDataJourney);
  // if (!this.listDataJourney || this.listDataJourney.length === 0) {
  //   return 'Indirizzo non disponibile';
  // }

  // // Ordina i journey per trip_id se necessario
  // const sortedJourneys = [...this.listDataJourney].sort((a, b) => a.trip_id - b.trip_id);
  // const firstJourney = sortedJourneys[0];

  // return firstJourney.addressStart ||
  //   `${firstJourney.start_lat.toFixed(6)}, ${firstJourney.start_lon.toFixed(6)}`;
}

/**
 * Recupera l'indirizzo di arrivo dell'ultimo journey
 */
getEndAddress(): string {
    return this.journeyService.getEndAddress(this.listDataJourney);
  // if (!this.listDataJourney || this.listDataJourney.length === 0) {
  //   return 'Indirizzo non disponibile';
  // }

  // // Ordina i journey per trip_id se necessario
  // const sortedJourneys = [...this.listDataJourney].sort((a, b) => a.trip_id - b.trip_id);
  // const lastJourney = sortedJourneys[sortedJourneys.length - 1];

  // return lastJourney.addressEnd ||
  //   `${lastJourney.end_lat.toFixed(6)}, ${lastJourney.end_lon.toFixed(6)}`;
}

// Determina se il punto di arrivo è attivo (IN_PROGRESS)
getEndStatus(): boolean {
  return this.journeyService.getEndStatus(this.listDataJourney);
//   // Se c'è un journey selezionato, usa il suo stato

//  if (!this.listDataJourney || this.listDataJourney.length === 0) {
//     return false;
//   }
//   // Altrimenti, controlla il percorso complessivo
//   // Verifica se l'ultimo journey nella lista è IN_PROGRESS

//   if (this.listDataJourney && this.listDataJourney.length > 0) {
//     const lastJourney = this.listDataJourney[0];

//     return lastJourney.status === 'IN_PROGRESS';
//   }

//   return false; // Default: non in corso
}

// Per coerenza, anche se la partenza è sempre verde
getStartStatus(): boolean {
  // Per ora restituisce sempre true (sempre verde)
  return true;
}

getSelectedJourney() {
  if (!this.listDataJourney || this.listDataJourney.length === 0) {
    return null;
  }
 // console.log('listDataJourney LAST:', this.listDataJourney[this.listDataJourney.length - 1]);
  // Trova il journey selezionato o l'ultimo journey attivo
  return this.listDataJourney.find(j => j.selected) ||
         this.listDataJourney.find(j => j.status === 'IN_PROGRESS') ||
         this.listDataJourney[this.listDataJourney.length - 1];
}





// Metodo per ottenere lo stato dell'alta frequenza
getJourneyHighFrequency(tripId: number): boolean {
  return this.journeySettings[tripId]?.highFrequency || false;
}

// Metodo per impostare lo stato dell'alta frequenza
setJourneyHighFrequency(tripId: number, enabled: boolean): void {
  if (!this.journeySettings[tripId]) {
    this.journeySettings[tripId] = { highFrequency: false };
  }

  this.journeySettings[tripId].highFrequency = enabled;
  console.log(`High frequency for journey ${tripId} set to: ${enabled}`);

  // Implementa qui la tua logica per l'alta frequenza

    // Emetti l'evento con il trip_id e lo stato di selezione
  this.highFrequency.emit({
    index: tripId,  // Passa il trip_id invece dell'indice
    show: enabled
  });

  // else {
  //   this.disableHighFrequency(tripId);
  // }
}

// enableHighFrequency(tripId: string) {
//   // Implementa qui la tua logica
// }

// disableHighFrequency(tripId: string) {
//   // Implementa qui la tua logica
// }

ngOnChanges(changes: SimpleChanges) {
  if (changes['routeSummaries']) {
    // Qui puoi gestire l'aggiornamento, ad esempio:
    // console.log('Nuovi routeSummaries:', this.routeSummaries);

    // Controlla se calculateTotalDistance restituisce 0
    const currentDistance = parseFloat(this.calculateTotalDistance().replace(/[^\d.]/g, ''));
    if (currentDistance === 0 && this.routeSummaries && this.routeSummaries.length > 0) {
      // Calcola la distanza totale dai routeSummaries
      const totalDistanceFromRoutes = this.routeSummaries.reduce((total, routeSection) => {
        if (routeSection && routeSection.summary && routeSection.summary.length) {
          // Converti da metri a chilometri se necessario
          const lengthInKm = routeSection.summary.length / 1000;
          return total + lengthInKm;
        }
        return total;
      }, 0);

      console.log('Distanza totale calcolata dai routeSummaries:', totalDistanceFromRoutes.toFixed(2), 'km');
      // Salva il valore calcolato in una proprietà del componente
      this.calculatedRouteDistance = totalDistanceFromRoutes;
    } else {
      // Reset il valore se non è necessario calcolarlo dai routeSummaries
      this.calculatedRouteDistance = null;
    }
  }

  if (changes['backClicked'] && changes['backClicked'].currentValue === true) {
    if (this.journeySettings) {
      Object.keys(this.journeySettings).forEach(tripId => {
        console.log('Disattivazione alta frequenza per tripId:', tripId);
        console.log('Stato alta frequenza prima della disattivazione:', this.journeySettings[tripId].highFrequency);
        if (this.journeySettings[tripId].highFrequency) {
          // Se era attivo, disattivalo
          this.journeySettings[tripId].highFrequency = false;
          // this.disableHighFrequency(tripId);
        }
      });
    }
  }

  // Carica configurazione e dati KPI quando cambiano i journey
  if (changes['listDataJourney'] && this.listDataJourney && this.listDataJourney.length > 0) {
    this.loadJourneyKpiConfig();
  }
}

/**
 * Carica la configurazione dei KPI per i journey
 */
private loadJourneyKpiConfig(): void {
  this.store.pipe(
    select(selectedCustomerSelector),
    take(1)
  ).subscribe(selectedCustomer => {
    const currentUserInfo: CurrentUserInfo = this.dataService.getCurrentUserInfo();

    if (!selectedCustomer?.uid || !currentUserInfo?.user?.uid) {
      console.warn('loadJourneyKpiConfig: Informazioni customer o utente non disponibili');
      return;
    }

    this.catalogService.getJourneyConfigFromAPI(selectedCustomer.uid, currentUserInfo.user.uid)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (configs) => {
        console.log('Configurazione KPI journey caricata per journey-details:', configs);

        // Reset degli array
        this.journeyKpiList = [];
        this.journeyKpiCustomList = [];

        if (configs && configs.length > 0) {
          const latestConfig = configs[0];
          const kpiJourneyData = latestConfig?.config?.mappingData?.kpiJourney;

          if (kpiJourneyData && Array.isArray(kpiJourneyData)) {
            // Dividi i KPI in base allo scope
            kpiJourneyData.forEach((kpi: any) => {
              if (kpi.scope === 'kpi') {
                this.journeyKpiList.push(kpi);
              } else if (kpi.scope === 'kpi_custom') {
                this.journeyKpiCustomList.push(kpi);
              }
            });

            // Ordina i KPI in base al campo order
            this.journeyKpiList.sort((a, b) => (a.order || 0) - (b.order || 0));
            this.journeyKpiCustomList.sort((a, b) => (a.order || 0) - (b.order || 0));

            console.log(`KPI journey caricati per journey-details - kpi: ${this.journeyKpiList.length}, kpi_custom: ${this.journeyKpiCustomList.length}`);

            // Carica i dati dei KPI per ogni journey
            this.loadKpiDataForAllJourneys();
          }
        }
      },
      error: (error) => {
        console.error('Errore nel caricamento della configurazione KPI journey:', error);
      }
    });
  });
}

/**
 * Carica i dati KPI per tutti i journey
 */
private loadKpiDataForAllJourneys(): void {
  if (!this.listDataJourney || this.listDataJourney.length === 0) {
    return;
  }

  // Per ogni journey, carica i suoi KPI
  this.listDataJourney.forEach(journey => {
    // Inizializza lo stato accordion per questo journey
    if (!this.journeyKpiAccordionState.has(journey.trip_id)) {
      this.journeyKpiAccordionState.set(journey.trip_id, {
        kpiOpen: false,
        kpiCustomOpen: false
      });
    }

    this.loadKpiDataForJourney(journey);
  });
}

/**
 * Carica i dati dei KPI per un singolo journey
 */
private loadKpiDataForJourney(journey: Journey): void {
  this.store.pipe(
    select(selectedCustomerSelector),
    take(1)
  ).subscribe(selectedCustomer => {
    if (!selectedCustomer?.uid || !this.vehicle?.uid) {
      console.warn(`loadKpiDataForJourney: Informazioni customer o veicolo non disponibili per journey ${journey.trip_id}`);
      return;
    }

    const userInfo: CurrentUserInfo = this.dataService.getCurrentUserInfo();
    const varUtc = userInfo.user?.preferences.timezone.label || 'utc';

    // IMPORTANTE: vogliamo l'orario così come mostrato (es. 10:08), SENZA convertirlo in UTC: il
    // fuso di riferimento per questi orari è già dichiarato a parte nel campo 'timezone: varUtc'
    // delle request qui sotto.
    const fromDate = journey.start_time;
    const toDate = journey.end_time;

    // Crea copie dei KPI per questo journey
    const journeyKpiListCopy = JSON.parse(JSON.stringify(this.journeyKpiList));
    const journeyKpiCustomListCopy = JSON.parse(JSON.stringify(this.journeyKpiCustomList));

    const requests: (Observable<any> | null)[] = [];
    // Richiesta per segnali (scope = 'kpi') - usa name
    if (journeyKpiListCopy.length > 0) {
      const signalRequest: WidgetRequest = {
        uidCustomer: selectedCustomer.uid,
        signals: journeyKpiListCopy.map(kpi => kpi.name),
        fromDate: fromDate,
        toDate: toDate,
        timezone: varUtc,
        aggregate: false,
        uidVehicles: [this.vehicle.uid]
      };

      requests.push(
        this.kpiCrudService.getSignalData(signalRequest)
      );
    } else {
      requests.push(null);
    }

    // Richiesta per KPI compositi (scope = 'kpi_custom') - usa uid

    if (journeyKpiCustomListCopy.length > 0) {
      const compositeRequest: WidgetRequest = {
        uidCustomer: selectedCustomer.uid,
        uidsKpi: journeyKpiCustomListCopy.map(kpi => kpi.uid),
        fromDate: fromDate,
        toDate: toDate,
        timezone: varUtc,
        aggregate: false,
        uidVehicles: [this.vehicle.uid]
      };

      requests.push(
        this.kpiCrudService.getCompositeSignalData(compositeRequest)
      );
    } else {
      requests.push(null);
    }

    // Esegui le richieste solo se ci sono dati da caricare
    const validRequests = requests.filter(req => req !== null);

    if (validRequests.length === 0) {
      console.log(`Nessun KPI da caricare per journey ${journey.trip_id}`);
      return;
    }

    forkJoin(validRequests)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (responses: any[]) => {
        console.log(`Dati KPI caricati per journey ${journey.trip_id}:`, responses);

        let responseIndex = 0;

        // Prima risposta: signal (scope = 'kpi', se presente)
        if (requests[0] !== null && responses[responseIndex]) {
          const signalData = responses[responseIndex];
          if (signalData.result === 'OK' && signalData.data && Array.isArray(signalData.data)) {
            signalData.data.forEach((dataItem: any) => {
              const kpi = journeyKpiListCopy.find(k => k.name === dataItem.result_signal);
              if (kpi) {
                kpi.value = dataItem.result_value;
                if (dataItem.result_avg_value) {
                  kpi.avgValue = dataItem.result_avg_value;
                }
              }
            });
          }
          responseIndex++;
        }

        // Seconda risposta: compositeSignal (scope = 'kpi_custom', se presente)
        if (requests[1] !== null && responses[responseIndex]) {
          const compositeData = responses[responseIndex];
          if (Array.isArray(compositeData) && compositeData.length > 0) {
            compositeData.forEach((dataItem: any) => {
              const kpi = journeyKpiCustomListCopy.find(k => k.uid === dataItem.uid);
              if (kpi) {
                kpi.value = dataItem.value;
              }
            });
          }
        }

        // Salva i KPI elaborati per questo journey
        this.journeyKpiData.set(journey.trip_id, {
          kpiList: journeyKpiListCopy,
          kpiCustomList: journeyKpiCustomListCopy
        });

        console.log(`KPI salvati per journey ${journey.trip_id}:`, this.journeyKpiData.get(journey.trip_id));
      },
      error: (error) => {
        console.error(`Errore nel caricamento dei dati KPI per journey ${journey.trip_id}:`, error);
      }
    });
  });
}

/**
 * Ottiene i KPI per un journey specifico
 */
getJourneyKpis(tripId: number): any[] {
  return this.journeyKpiData.get(tripId)?.kpiList || [];
}

/**
 * Ottiene i KPI custom per un journey specifico
 */
getJourneyKpiCustoms(tripId: number): any[] {
  return this.journeyKpiData.get(tripId)?.kpiCustomList || [];
}

/**
 * Toggle accordion KPI per un journey
 */
toggleJourneyKpiAccordion(tripId: number, type: 'kpi' | 'kpi_custom'): void {
  const state = this.journeyKpiAccordionState.get(tripId);
  if (state) {
    if (type === 'kpi') {
      state.kpiOpen = !state.kpiOpen;
    } else {
      state.kpiCustomOpen = !state.kpiCustomOpen;
    }
  }
}

/**
 * Ottiene lo stato accordion per un journey
 */
getJourneyKpiAccordionState(tripId: number): { kpiOpen: boolean, kpiCustomOpen: boolean } {
  return this.journeyKpiAccordionState.get(tripId) || { kpiOpen: false, kpiCustomOpen: false };
}

/**
 * Getter per la lingua corrente
 */
get currentLang(): string {
  return this.dataService.getLanguage() || 'it-IT';
}

/**
 * Ottiene la label localizzata per un KPI custom
 */
getLocalizedLabel(kpi: any): string {
  if (kpi.i18nLabel && typeof kpi.i18nLabel === 'object') {
    const lang = this.currentLang;
    console.log('getLocalizedLabel - currentLang:', lang, '- i18nLabel:', kpi.i18nLabel);

    // Cerca prima con la chiave esatta (es: "en-US")
    if (kpi.i18nLabel[lang]) {
      return kpi.i18nLabel[lang];
    }

    // Se non trovato, cerca una chiave che inizia con la lingua (es: "en" -> "en-US")
    const matchingKey = Object.keys(kpi.i18nLabel).find(key =>
      key.toLowerCase().startsWith(lang.toLowerCase())
    );

    if (matchingKey && kpi.i18nLabel[matchingKey]) {
      return kpi.i18nLabel[matchingKey];
    }

    // Fallback su label o name
    return kpi.label || kpi.name || '';
  }
  return kpi.label || kpi.name || '';
}




//  getVehiclePosition(tripId:number) {

//     this.journeyService.getVehiclePositions(["AB5005FB-9C06-4AF8-A673-05E93D32F9CA"],"2025-06-03 00:00:00","2025-06-03 23:59:59").subscribe({
//       next: (data) => {

//         console.log('Posizione veicolo ricevuta:', data);
//       },
//       error: (err) => {

//         console.error('Errore:', err);
//       }
//     });
//   }

 getTotalRouteLength(): number {
  if (!Array.isArray(this.routeSummaries)) return 0;
  return this.routeSummaries.reduce((sum, summary) => sum + (summary.length || 0), 0);
}
}
